/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_RefreshInputs */

const en_auto_refresh = /** @type {(inputs: Auto_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Refresh`)
};

const fr_auto_refresh = /** @type {(inputs: Auto_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rafraîchissement auto`)
};

const de_auto_refresh = /** @type {(inputs: Auto_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Aktualisierung`)
};

const it_auto_refresh = /** @type {(inputs: Auto_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento automatico`)
};

const ru_auto_refresh = /** @type {(inputs: Auto_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое обновление`)
};

const es_auto_refresh = /** @type {(inputs: Auto_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización automática`)
};

const zh_cn2_auto_refresh = /** @type {(inputs: Auto_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动刷新`)
};

const ja_auto_refresh = /** @type {(inputs: Auto_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動更新`)
};

const hi_auto_refresh = /** @type {(inputs: Auto_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो रिफ्रेश`)
};

const pt_pt2_auto_refresh = /** @type {(inputs: Auto_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização automática`)
};

/**
* | output |
* | --- |
* | "Auto Refresh" |
*
* @param {Auto_RefreshInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_refresh = /** @type {((inputs?: Auto_RefreshInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_RefreshInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_refresh(inputs)
	if (locale === "de") return de_auto_refresh(inputs)
	if (locale === "it") return it_auto_refresh(inputs)
	if (locale === "ru") return ru_auto_refresh(inputs)
	if (locale === "es") return es_auto_refresh(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_refresh(inputs)
	if (locale === "ja") return ja_auto_refresh(inputs)
	if (locale === "hi") return hi_auto_refresh(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_refresh(inputs)
	return en_auto_refresh(inputs)
});